import cn from "@/utils/mergeClassNames";

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const LoadingBars = ({ className, ...props }: Props) => {
  return (
    <div className={cn("loading_container", className)} {...props}>
      <div className="loading_bars"></div>
      <div className="loading_bars"></div>
      <div className="loading_bars"></div>
    </div>
  );
};

export default LoadingBars;
